import Payment from './Payment';
import Price from './Price';

Payment.Price = Price;

export default Payment;
